import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Spin, Input } from "antd";
interface props {
    isVisible: boolean;
    isLoading: boolean;
    handleNewAgentNoteCb: (text: string) => void;
    handleCancelNotesModalCb: () => void;
}
function NotesModal({
    isVisible,
    isLoading,
    handleNewAgentNoteCb,
    handleCancelNotesModalCb,
}: props) {
    const { t } = useTranslation();
    const [noteTextInput, setNoteTextInput] = useState("");
    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const target = event.target as HTMLTextAreaElement;
        setNoteTextInput(target.value);
    };
    const handleSendNote = () => {
        setNoteTextInput("");
        handleNewAgentNoteCb(noteTextInput);
    };
    return (
        <Modal
            title={t("notes.create")}
            open={isVisible}
            onOk={handleSendNote}
            onCancel={handleCancelNotesModalCb}
        >
            <Spin spinning={isLoading}>
                <Input.TextArea
                    value={noteTextInput}
                    onChange={handleChange}
                    placeholder={t("notes.notePlaceholder")}
                />
                <p style={{ fontSize: "12px" }}>{t("notes.description")}</p>
            </Spin>
        </Modal>
    );
}
export default NotesModal;
